import { render, staticRenderFns } from "./phrase.vue?vue&type=template&id=553d6b40&"
import script from "./phrase.vue?vue&type=script&lang=ts&"
export * from "./phrase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports